/**
 * Handle storing arbitrary values in localStorage by stringifying them first.
 *
 * All values are obfuscated by encoding as base64.
 */
export class Storage {
  store(key, value) {
    let keyStringified = JSON.stringify(key);
    let keyBase64 = btoa(keyStringified);

    let valueStringified = JSON.stringify(value);
    let valueBase64 = btoa(valueStringified);

    return window.localStorage.setItem(keyBase64, valueBase64);
  }

  retrieve(key) {
    let keyStringified = JSON.stringify(key);
    let keyBase64 = btoa(keyStringified);

    let valueBase64 = window.localStorage.getItem(keyBase64);
    if (valueBase64 === null) {
      return null;
    }
    let valueStringified = atob(valueBase64);
    let value = JSON.parse(valueStringified);

    return value;
  }

  remove(key) {
    let keyStringified = JSON.stringify(key);
    let keyBase64 = btoa(keyStringified);

    return window.localStorage.removeItem(keyBase64);
  }
}

/**
 * Prefix all stored values with a version id/number.
 */
export class ClientSettings {
  constructor(id) {
    this.id = id;
    this._storage = new Storage();
  }

  store(key, value) {
    return this._storage.store(this.id + '.' + key, value);
  }

  retrieve(key) {
    return this._storage.retrieve(this.id + '.' + key);
  }

  remove(key) {
    return this._storage.remove(this.id + '.' + key);
  }
}



// WEBPACK FOOTER //
// ./src/storage.js